/* unplugin-vue-components disabled */import { render } from "./footer.vue?vue&type=template&id=45727b7e&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=45727b7e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45727b7e"]])

export default __exports__